// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"63982793","208":"ac1dcb8a","653":"6f874ebc","828":"f6ae707a"}[chunkId] + ".chunk.css";
};